module.exports = __webpack_public_path__ + "static/media/home.d4d8032c.png";